module.exports = __webpack_public_path__ + "static/media/calendar.aeef2bba.svg";